import React, { useState, useEffect } from "react";
import styled from "styled-components";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import { PieChart } from '../../../common/ReusableComponent/Chart';

const ChartContainer = styled.div`
  width: 400px;
  height: 270px;
  margin: 20px auto;
  background-color: #fff;
  border-radius: 40px;
  text-align: center;
  border: 1px solid #ebeaf2;
  box-shadow: 0px 2px 8px rgba(6, 12, 34, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const SoldProductCategory = () => {
  const [chartData, setChartData] = useState(null);
  const { Post } = useApi();
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const fetchChartData = async () => {
      try {
        const response = await Post("mostSoldProductByCategory", {
          start_date: `${currentYear}-01-01`,
          end_date: `${currentYear}-12-31`,
        });

        const categories = response.data.top_5_categories || [];

        if (categories.length === 0) {
          setChartData(null);
          return;
        }

        const labels = categories.map((item) => item.category || "Unknown");
        const values = categories.map((item) => item.sold_percentage || 0);

        setChartData({
          labels,
          datasets: [
            {
              label: "Most Sold Categories (%)",
              data: values,
              backgroundColor: [
                "rgba(255, 99, 132, 0.6)",
                "rgba(54, 162, 235, 0.6)",
                "rgba(75, 192, 192, 0.6)",
                "rgba(153, 102, 255, 0.6)",
                "rgba(255, 159, 64, 0.6)",
              ],
              borderColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
              ],
              borderWidth: 1,
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching chart data:", error);
        setChartData(null);
      }
    };

    fetchChartData();
  }, []);

  return (
    <ChartContainer>
      {chartData ? (
        <PieChart
          labels={chartData.labels}
          datasets={chartData.datasets}
          title="Most Sold Product Categories"
          theme="custom"
          height="230px"
          width="350px"
          legendPosition="top"
          noBorder={true}
          noShadow={true}
        />
      ) : (
        <p style={{
          fontSize: '16px',
          color: '#999',
          textAlign: 'center',
          fontStyle: 'italic',
          margin: 0,
        }}>
          No data available
        </p>
      )}
    </ChartContainer>
  );
};

export default SoldProductCategory;
